/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import s from './Footer.css';
import Link from '../Link';
import { 
  ILEXCONNECT_URL,
  SPIROTECH_URL,
  TEST_SPIROTECH_URL
} from '../../constants/websites';
import Messages from './Messages';


class Footer extends React.Component {
  getIsSpirotech = (producent, runtime) => {
    const host = runtime.host;
    const hostname = runtime.hostname;
    // const host = SPIROTECH_URL;
    // const hostname = SPIROTECH_URL;
    return producent === 'spirotech' || 
      hostname === SPIROTECH_URL || 
      hostname === TEST_SPIROTECH_URL;
  };

  render() {
    const { runtime, authentication } = this.props;
    const messages = Messages();
    const producent = authentication.get('producent');
    const isSpirotech = this.getIsSpirotech(producent, runtime);
    const wrappedStyle = isSpirotech ? cx(s.root, s.spirotech) : cx(s.root);
    const linkStyle = isSpirotech ? cx(s.link_spirotech, s.link) : cx(s.link);
    return (
      <div className={wrappedStyle}>
        <div className={s.container}>
          <Link className={linkStyle} to="/">
            Start
          </Link>
          <span className={s.spacer}>·</span>
          <Link className={linkStyle} to="/privacy/cookies">
            <FormattedMessage {...messages.cookies_footer_text}/>
          </Link>
          <span className={s.spacer}>·</span>
          <Link className={linkStyle} to="/privacy/gdpr">
            <FormattedMessage {...messages.privacy_footer_text}/>
          </Link>
        </div>
      </div>
    );
  }
}


const mapState = state => ({
  authentication: state.authentication,
  runtime: state.runtime,
});

Footer.propTypes = {
  authentication: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
}

export default  injectIntl(compose(withStyles(s), connect(mapState, null))(
  Footer
));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js